module.exports = __webpack_public_path__ + "static/media/girod.191d6b3f.jpg";